import React from "react";
import { Snackbar, Alert } from "@mui/material";
import useToastStore from "../../store/toastStore";

function Toast() {
  const { open, message, severity, hideToast } = useToastStore();

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={hideToast}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={hideToast}
        severity={severity}
        variant="filled"
        sx={{ width: "100%", fontWeight: 500 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Toast;
